import React from 'react';
import './Products.css';
import { FaHospital, FaClock, FaComments, FaUsers, FaWhatsapp, FaCertificate } from 'react-icons/fa';

const Products = () => {
  const products = [
    {
      icon: <FaHospital />,
      title: 'Hospital Management System',
      description: 'An integrated end-to-end platform designed to optimize hospital operations, covering patient registration through billing and inventory management.',
      features: ['Outpatient (OP) Management', 'Inpatient (IP) Management', 'Clinical Support Services', 'Pharmacy & Diagnostics', 'Billing & Finance', 'Materials & Assets', 'HR & Employee Services', 'Dashboards & Reporting']
    },
    {
      icon: <FaClock />,
      title: 'Queue Management System',
      description: 'Intelligent queue management to reduce wait times, improve patient flow, and enhance overall patient experience.',
      features: ['Digital Token System', 'Real-time Updates', 'SMS/Email Alerts', 'Analytics Dashboard']
    },
    {
      icon: <FaComments />,
      title: 'Feedback System',
      description: 'Leverage patient feedback through intelligent capture and analysis to drive continuous improvement in healthcare service quality.',
      features: ['Multi-channel Feedback', 'Sentiment Analysis', 'Action Tracking', 'Reports & Insights']
    },
    {
      icon: <FaUsers />,
      title: 'HR Software for Hospitals',
      description: 'Comprehensive human resource management tailored for healthcare facilities with complex shift patterns.',
      features: ['Staff Scheduling', 'Payroll Management', 'Attendance Tracking', 'Performance Reviews']
    },
    {
      icon: <FaWhatsapp />,
      title: 'WhatsApp BOT',
      description: 'Automated WhatsApp-based patient engagement system enabling seamless communication and service delivery.',
      features: ['Appointment Booking', 'Lab e-Results', 'Patient e-Card', 'Automated Notifications']
    },
    {
      icon: <FaCertificate />,
      title: 'NABH & JCI Compliance',
      description: 'Built-in compliance features to help achieve and maintain NABH and JCI accreditation standards.',
      features: ['Compliance Tracking', 'Audit Reports', 'Standard Templates', 'Documentation Support']
    }
  ];

  const modules = [
    {
      category: 'Outpatient (OP) Management',
      items: ['Inquiry Management', 'Appointment / Booking', 'Front Office Management', 'Department Billing (OP Billing)', 'OP EMR', 'Queue Management', 'Visitor Management']
    },
    {
      category: 'Inpatient (IP) Management',
      items: ['Admission & Bed Management', 'IP EMR', 'Nursing Station', 'IP Packages', 'Discharge Clearance Process', 'Discharge Summary', 'MRD (Medical Records Department)']
    },
    {
      category: 'Clinical Support Services',
      items: ['OT EMR', 'Dialysis Module', 'Mortuary Management']
    },
    {
      category: 'Pharmacy & Diagnostics',
      items: ['Pharmacy Management', 'Laboratory Management']
    },
    {
      category: 'Billing & Finance',
      items: ['Central Cash Counter', 'Department Billing', 'Insurance Management', 'Finance Management']
    },
    {
      category: 'Materials & Assets',
      items: ['Inventory Management', 'Purchase Management', 'Asset Management']
    },
    {
      category: 'HR & Employee Services',
      items: ['Human Resource Management', 'Employee Self Service Portal']
    },
    {
      category: 'Dashboards & Reporting',
      items: ['Management Dashboards', 'Standard Reports & Custom Reports']
    },
    {
      category: 'Administration / Master Data',
      items: ['Masters Management']
    },
    {
      category: 'Integrations',
      items: ['SMS/ WhatsApp', 'Tally', 'PACS', 'Asset Management', 'Laboratory Machine', 'Biometric', 'ICD / CIMS / SNOMED CT', 'POS', 'Payment Gateway', 'Barcode', 'Kiosk']
    }
  ];

  return (
    <section id="products" className="products section">
      <div className="container">
        <h2 className="section-title">Our <span className="gradient-text">Products & Services</span></h2>
        <p className="section-subtitle">
          Comprehensive healthcare software solutions designed to transform hospital operations 
          and deliver exceptional patient care
        </p>

        <div className="products-grid">
          {products.map((product, index) => (
            <div key={index} className="product-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="product-icon">{product.icon}</div>
              <h3 className="product-title">{product.title}</h3>
              <p className="product-description">{product.description}</p>
              <ul className="product-features">
                {product.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="modules-section">
          <h2 className="section-title" style={{ marginTop: '80px' }}>
            GrandisHIS <span className="gradient-text">Module List</span>
          </h2>
          <p className="section-subtitle">
            Comprehensive modules covering every aspect of hospital operations
          </p>
          
          <div className="modules-grid">
            {modules.map((module, index) => (
              <div key={index} className="module-card" style={{ animationDelay: `${index * 0.05}s` }}>
                <h3 className="module-category">{module.category}</h3>
                <ul className="module-items">
                  {module.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
